var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightStriking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 96,
    viewBox: "0 0 56 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_16393_18276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2388 8.23064L5.54642 45.7384C5.54642 45.7384 4.90804 47.4929 5.54642 48.206C6.07283 48.794 7.4905 48.6995 7.4905 48.6995H17.2109L5.54642 86.7007C5.54642 86.7007 4.67158 88.6748 6.03244 89.6619C7.39329 90.6489 8.94855 89.1683 8.94855 89.1683L49.4905 36.8433C49.4905 36.8433 51.4345 34.7636 50.7462 33.4003C50.2799 32.4767 48.3161 32.4132 48.3161 32.4132H37.6237L48.8021 8.23064C48.8021 8.23064 49.1629 6.93488 48.8021 6.25655C48.1747 5.07674 46.3721 5.26951 46.3721 5.26951H19.156C19.156 5.26951 17.9353 5.26951 17.2119 6.25655C16.7447 6.89405 16.2388 8.23064 16.2388 8.23064Z",
    fill: "url(#paint0_linear_16393_18276)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9761 4.97283L2.28372 42.4805C2.28372 42.4805 1.64535 44.2351 2.28372 44.9482C2.81014 45.5361 4.2278 45.4417 4.2278 45.4417H13.9482L2.28372 83.4429C2.28372 83.4429 1.40889 85.417 2.76974 86.404C4.1306 87.3911 5.68586 85.9105 5.68586 85.9105L46.2278 33.5854C46.2278 33.5854 48.1718 31.5058 47.4835 30.1425C47.0172 29.2189 45.0534 29.1554 45.0534 29.1554H34.361L45.5395 4.97283C45.5395 4.97283 45.9002 3.67707 45.5395 2.99874C44.912 1.81893 43.1094 2.01169 43.1094 2.01169H15.8933C15.8933 2.01169 14.6726 2.01169 13.9492 2.99874C13.482 3.63624 12.9761 4.97283 12.9761 4.97283Z",
    fill: "url(#paint1_linear_16393_18276)",
    stroke: "#FFC120",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_16393_18276",
    x: 0.262695,
    y: 0.257812,
    width: 55.6309,
    height: 94.7441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_16393_18276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16393_18276",
    x1: 53.3786,
    y1: 47.7008,
    x2: 5.26269,
    y2: 47.7008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411789,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16393_18276",
    x1: 50.1159,
    y1: 44.4429,
    x2: 2,
    y2: 44.4429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411789,
    stopColor: "#FFB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightStriking);
export default __webpack_public_path__ + "static/media/light-striking.bbd4b7a85e74805554b1f33c596f7e50.svg";
export { ForwardRef as ReactComponent };